import { ApiUrls } from '@api/api.urls';
import { makeAxiosRequest } from '@api/apiUtils/makeAxiosRequest';

import type { FundFromOriginResponse } from './api.funds.types';

export const retrieveFundFromOrigin = () => {
  const url = ApiUrls.funds.fundFromOrigin;
  return makeAxiosRequest<FundFromOriginResponse>({
    url,
    method: 'get',
  });
};
